import { gql, useQuery } from '@apollo/client';
import {
  TRANSLATED_STRING_FIELDS,
  translateBackend,
} from '@assets/i18n/config';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';

const FETCH_CONFIGURABLE_TABLE_PAGE = gql`
  query fetchConfigurableTablePageName($configurableTablePageId: ObjectID!) {
    fetchConfigurableTablePage(configurableTablePageId: $configurableTablePageId) {
      configurableTablePage {
        name { ${TRANSLATED_STRING_FIELDS} }
      }
    }
  }
`;
export const ConfigurableTablePageBreadcrumb = () => {
  const { t } = useTranslation('navMenu');
  const { configurableTablePageId } = useParams<{
    configurableTablePageId: string;
  }>();

  const { data } = useQuery(FETCH_CONFIGURABLE_TABLE_PAGE, {
    variables: { configurableTablePageId: configurableTablePageId! },
    skip: !configurableTablePageId,
  });

  return data
    ? translateBackend(
        data.fetchConfigurableTablePage?.configurableTablePage.name,
      )
    : t('menu.configurableTablePage');
};
